import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedTab: 'READY',
  currentPage: 1,
  searchQuery: '',
  branchfilter: [],
  stagefilter: [],
  productfilter: [],
  loan: {},
  type: '',
  applicationType: '',
  isLoanSearch: false,
  globalConfig: {},
};

const loanListPayloadSlice = createSlice({
  name: 'loanListPayload',
  initialState,
  reducers: {
    setLoanPayLoadValue: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    loanValue: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetLoanPayLoadValue: () => initialState,
  },
});

export const { setLoanPayLoadValue, loanValue, resetLoanPayLoadValue } =
  loanListPayloadSlice.actions;

export default loanListPayloadSlice.reducer;
